// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M17.1,8l3.3-5H5V2H4v20h1v-9h15.4L17.1,8z M5,4h13.6l-2.7,4l2.7,4H5V4z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-flag-BObBtSEJ.js.map
